import { useTranslation } from "@redotech/redo-i18n";
import { NumItemsInReturnOption } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import type { NumItemsInReturnState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

export const NumItemsInReturnDetails = memo(function NumItemsInReturnDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<NumItemsInReturnState>) {
  const { t } = useTranslation();
  const numItemsOptions: RedoListItem<NumItemsInReturnOption>[] = useMemo(
    () =>
      Object.values(NumItemsInReturnOption).map((option) => ({
        id: option,
        value: option,
        type: "text" as const,
        text:
          option === NumItemsInReturnOption.LESS_THAN
            ? t("Less than")
            : option === NumItemsInReturnOption.GREATER_THAN
              ? t("Greater than")
              : t("Equals"),
      })),
    [t],
  );

  const selectedOption = state.numItemsOption
    ? numItemsOptions.find((option) => option.value === state.numItemsOption)
    : undefined;

  return (
    <>
      <RedoSingleSelectDropdownInput
        disabled={disabled}
        flexGrow
        label={t("Match type")}
        options={numItemsOptions}
        optionSelected={({ item }) =>
          setState({ ...state, numItemsOption: item.value })
        }
        placeholder={t("Select match type...")}
        selectedItem={selectedOption}
        size="xs"
      />
      <RedoTextInput
        label={t("Number of items in return")}
        min={0}
        onBlur={() =>
          setState({ ...state, numItems: (+state.numItems).toFixed(0) })
        }
        setValue={(e) => setState({ ...state, numItems: e })}
        state={disabled ? "readonly" : "default"}
        value={state.numItems}
      />
    </>
  );
});
